import React, { useEffect, useState } from 'react'
import Card from "../../../core/Card";
import style from "../../../views/style.module.css";
import { useTranslation } from "react-i18next";

const DeleteWarning = ({ id, title, messageStr, onSuccess, data }) => {
    //States
    const [deleteData, setDeleteData] = useState()
  const { t } = useTranslation();

    //Effects
    useEffect(() => {
        setDeleteData(data)
    }, [data])

    return (
        <>
            <div className="customvar-modal modal custom-modal fade deleteModal" id={id} tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>{title}</h3>
                                                <div dangerouslySetInnerHTML={{ __html: messageStr }}>
                                                </div>
                                            </div>


                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" data-bs-dismiss="modal">{t('survey.customVariable.cancel')}</button>
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => onSuccess(deleteData)}>{t("settings.roles.delete_action.delete")}</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DeleteWarning